/**
 * 支持的编程语言配置
 */

export const languages = [
  {
    id: 'python',
    name: 'Python',
    displayName: 'Python (requests)',
    extension: 'py',
    category: 'backend',
    icon: '🐍',
    generator: 'PythonGenerator',
    highlight: 'python',
    dependencies: ['requests'],
    description: '使用 Python requests 库发送 HTTP 请求',
    example: `import requests

# 发送 GET 请求
response = requests.get('https://api.example.com/data')
print(response.json())`,
    popularity: 95
  },
  {
    id: 'javascript',
    name: 'JavaScript',
    displayName: 'JavaScript (fetch)',
    extension: 'js',
    category: 'web',
    icon: '🟨',
    generator: 'JavaScriptGenerator',
    highlight: 'javascript',
    dependencies: [],
    description: '使用原生 fetch API 发送 HTTP 请求',
    example: `// 发送 GET 请求
fetch('https://api.example.com/data')
  .then(response => response.json())
  .then(data => console.log(data))
  .catch(error => console.error(error));`,
    popularity: 90
  },
  {
    id: 'nodejs',
    name: 'Node.js',
    displayName: 'Node.js (axios)',
    extension: 'js',
    category: 'backend',
    icon: '📦',
    generator: 'NodeJsGenerator',
    highlight: 'javascript',
    dependencies: ['axios'],
    description: '使用 axios 库在 Node.js 中发送 HTTP 请求',
    example: `const axios = require('axios');

axios.get('https://api.example.com/data')
  .then(response => {
    console.log(response.data);
  })
  .catch(error => {
    console.error(error);
  });`,
    popularity: 85
  },
  {
    id: 'java',
    name: 'Java',
    displayName: 'Java (HttpURLConnection)',
    extension: 'java',
    category: 'backend',
    icon: '☕',
    generator: 'JavaGenerator',
    highlight: 'java',
    dependencies: [],
    description: '使用 Java 原生 HttpURLConnection 发送 HTTP 请求',
    example: `import java.net.HttpURLConnection;
import java.net.URL;
import java.io.BufferedReader;
import java.io.InputStreamReader;

URL url = new URL("https://api.example.com/data");
HttpURLConnection conn = (HttpURLConnection) url.openConnection();
conn.setRequestMethod("GET");

BufferedReader reader = new BufferedReader(
    new InputStreamReader(conn.getInputStream()));
String line;
StringBuilder response = new StringBuilder();
while ((line = reader.readLine()) != null) {
    response.append(line);
}
reader.close();

System.out.println(response.toString());`,
    popularity: 80
  },
  {
    id: 'go',
    name: 'Go',
    displayName: 'Go (net/http)',
    extension: 'go',
    category: 'backend',
    icon: '🔵',
    generator: 'GoGenerator',
    highlight: 'go',
    dependencies: [],
    description: '使用 Go 标准库 net/http 发送 HTTP 请求',
    example: `package main

import (
    "fmt"
    "io"
    "net/http"
)

func main() {
    resp, err := http.Get("https://api.example.com/data")
    if err != nil {
        fmt.Println(err)
        return
    }
    defer resp.Body.Close()

    body, err := io.ReadAll(resp.Body)
    if err != nil {
        fmt.Println(err)
        return
    }

    fmt.Println(string(body))
}`,
    popularity: 75
  },
  {
    id: 'php',
    name: 'PHP',
    displayName: 'PHP (cURL)',
    extension: 'php',
    category: 'backend',
    icon: '🐘',
    generator: 'PhpGenerator',
    highlight: 'php',
    dependencies: [],
    description: '使用 PHP cURL 扩展发送 HTTP 请求',
    example: `<?php
$ch = curl_init();

curl_setopt($ch, CURLOPT_URL, 'https://api.example.com/data');
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

$response = curl_exec($ch);

if (curl_errno($ch)) {
    echo 'Error: ' . curl_error($ch);
} else {
    echo $response;
}

curl_close($ch);
?>`,
    popularity: 70
  },
  {
    id: 'csharp',
    name: 'C#',
    displayName: 'C# (HttpClient)',
    extension: 'cs',
    category: 'backend',
    icon: '💜',
    generator: 'CSharpGenerator',
    highlight: 'csharp',
    dependencies: ['System.Net.Http'],
    description: '使用 .NET HttpClient 发送 HTTP 请求',
    example: `using System;
using System.Net.Http;
using System.Threading.Tasks;

class Program
{
    static async Task Main()
    {
        using (HttpClient client = new HttpClient())
        {
            try
            {
                HttpResponseMessage response = await client.GetAsync("https://api.example.com/data");
                response.EnsureSuccessStatusCode();
                string responseBody = await response.Content.ReadAsStringAsync();
                Console.WriteLine(responseBody);
            }
            catch (HttpRequestException e)
            {
                Console.WriteLine($"Error: {e.Message}");
            }
        }
    }
}`,
    popularity: 65
  },
  {
    id: 'ruby',
    name: 'Ruby',
    displayName: 'Ruby (Net::HTTP)',
    extension: 'rb',
    category: 'backend',
    icon: '💎',
    generator: 'RubyGenerator',
    highlight: 'ruby',
    dependencies: [],
    description: '使用 Ruby 标准库 Net::HTTP 发送 HTTP 请求',
    example: `require 'net/http'
require 'uri'

uri = URI('https://api.example.com/data')
response = Net::HTTP.get_response(uri)

if response.is_a?(Net::HTTPSuccess)
  puts response.body
else
  puts "Error: #{response.code} #{response.message}"
end`,
    popularity: 60
  },
  {
    id: 'swift',
    name: 'Swift',
    displayName: 'Swift (URLSession)',
    extension: 'swift',
    category: 'mobile',
    icon: '🦉',
    generator: 'SwiftGenerator',
    highlight: 'swift',
    dependencies: [],
    description: '使用 Swift URLSession 发送 HTTP 请求',
    example: `import Foundation

let url = URL(string: "https://api.example.com/data")!
let task = URLSession.shared.dataTask(with: url) { data, response, error in
    if let error = error {
        print("Error: \(error.localizedDescription)")
        return
    }
    
    if let data = data {
        if let responseString = String(data: data, encoding: .utf8) {
            print(responseString)
        }
    }
}

task.resume()`,
    popularity: 55
  },
  {
    id: 'kotlin',
    name: 'Kotlin',
    displayName: 'Kotlin (OkHttp)',
    extension: 'kt',
    category: 'backend',
    icon: '🎯',
    generator: 'KotlinGenerator',
    highlight: 'kotlin',
    dependencies: ['com.squareup.okhttp3:okhttp:4.10.0'],
    description: '使用 Kotlin 和 OkHttp 发送 HTTP 请求',
    example: `import okhttp3.OkHttpClient
import okhttp3.Request

fun main() {
    val client = OkHttpClient()
    val request = Request.Builder()
        .url("https://api.example.com/data")
        .build()

    client.newCall(request).execute().use { response ->
        if (!response.isSuccessful) {
            println("Error: \${response.code}")
            return
        }
        
        println(response.body?.string())
    }
}`,
    popularity: 50
  }
];

/**
 * 按类别分组的语言
 */
export const languagesByCategory = {
  web: languages.filter(lang => lang.category === 'web'),
  backend: languages.filter(lang => lang.category === 'backend'),
  mobile: languages.filter(lang => lang.category === 'mobile')
};

/**
 * 类别配置
 */
export const languageCategories = [
  { id: 'web', name: 'Web 开发', icon: '🌐', description: '前端和全栈开发语言' },
  { id: 'backend', name: '后端开发', icon: '⚙️', description: '服务器端编程语言' },
  { id: 'mobile', name: '移动开发', icon: '📱', description: '移动应用开发语言' }
];

/**
 * 获取语言配置
 * @param {string} languageId - 语言 ID
 * @returns {Object|null} 语言配置对象
 */
export function getLanguageConfig(languageId) {
  return languages.find(lang => lang.id === languageId) || null;
}

/**
 * 获取默认语言
 * @returns {Object} 默认语言配置
 */
export function getDefaultLanguage() {
  return languages.find(lang => lang.id === 'python') || languages[0];
}

/**
 * 获取热门语言（按流行度排序）
 * @param {number} limit - 返回数量限制
 * @returns {Array} 热门语言数组
 */
export function getPopularLanguages(limit = 6) {
  return [...languages]
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, limit);
}

/**
 * 搜索语言
 * @param {string} query - 搜索关键词
 * @returns {Array} 匹配的语言
 */
export function searchLanguages(query) {
  const lowerQuery = query.toLowerCase();
  return languages.filter(language =>
    language.name.toLowerCase().includes(lowerQuery) ||
    language.displayName.toLowerCase().includes(lowerQuery) ||
    language.description.toLowerCase().includes(lowerQuery)
  );
}

/**
 * 获取语言统计信息
 * @returns {Object} 统计数据
 */
export function getLanguageStats() {
  return {
    total: languages.length,
    categories: Object.keys(languagesByCategory).length,
    mostPopular: languages.reduce((prev, current) =>
      (prev.popularity > current.popularity) ? prev : current
    ),
    webLanguages: languagesByCategory.web.length,
    backendLanguages: languagesByCategory.backend.length,
    mobileLanguages: languagesByCategory.mobile.length
  };
}

/**
 * 检查语言是否支持
 * @param {string} languageId - 语言 ID
 * @returns {boolean} 是否支持
 */
export function isLanguageSupported(languageId) {
  return languages.some(lang => lang.id === languageId);
}

/**
 * 获取语言的语法高亮配置
 * @param {string} languageId - 语言 ID
 * @returns {string} Prism.js 语言标识符
 */
export function getHighlightLanguage(languageId) {
  const config = getLanguageConfig(languageId);
  return config ? config.highlight : 'plaintext';
}

/**
 * 获取语言的文件扩展名
 * @param {string} languageId - 语言 ID
 * @returns {string} 文件扩展名
 */
export function getFileExtension(languageId) {
  const config = getLanguageConfig(languageId);
  return config ? config.extension : 'txt';
}